import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { isArchivedFilter } from '../data'

interface AuditLog {
  Audit: any;
  AuditTime: string;
  ItemCreated: string;
}

interface GroupedByDay {
  auditByDates: AuditLog[];
  day: string;
}
interface PIIAuditTrailMetadataArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  onePageOnly?: boolean
  orderBy?: string
  pageNumber?: number
}
interface PIIAuditTrail {
  Comment: string
  DocumentPath: string
  EntityCode: string
  EntityType: string
  FileName: string
  InquiryID?:string
  ItemCode: string
  ItemCreated?: Date
  ItemCreatedBy?: any
  'ItemCreatedBy/edipi'?: string
  'ItemCreatedBy/email'?: string
  'ItemCreatedBy/firstname'?: string
  'ItemCreatedBy/lastname'?
  ItemGUID: string
  ItemModified?: Date
  ItemModifiedBy?: any
  'ItemModifiedBy/edipi'?: string
  'ItemModifiedBy/email'?: string
  'ItemModifiedBy/firstname'?: string
  'ItemModifiedBy/latname'?: string
  ItemType?: string
  JsonResults: any
  UserAnswer: any
}
const PAGE_SIZE = 100
const LIST_NAME = 'PIIAuditTrailList'
const COLUMN_NAMES = {
  Comment: 'Comment',
  DocumentPath: 'DocumentPath',
  ETag: 'eTag',
  Ekey: 'eKey',
  EntityCode: 'EntityCode',
  EntityType: 'EntityType',
  FileName: 'FileName',
  InquiryID:'InquiryID',
  ItemCode: 'ItemCode',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByEDIPI: 'ItemCreatedBy/edipi',
  ItemCreatedByEmail: 'ItemCreatedBy/email',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstname',
  ItemCreatedByLastName: 'ItemCreatedBy/lastname',
  ItemGUID: 'ItemGUID',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemModifiedByEDIPI: 'ItemModifiedBy/edipi',
  ItemModifiedByEmail: 'ItemModifiedBy/email',
  ItemModifiedByFirstName: 'ItemModifiedBy/firstname',
  ItemModifiedByLastName: 'ItemModifiedBy/lastname',
  ItemType: 'ItemType',
  JsonResults: 'JsonResults',
  UserAnswer: 'UserAnswer',
}

const getPIIAuditTrailListMetadata = async (
  args: PIIAuditTrailMetadataArgs
): Promise<PIIAuditTrail[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? false
  const orderBy = args?.orderBy ?? COLUMN_NAMES.ItemCreated
  const onePageOnly = args.onePageOnly ?? true
  const pageNum = args.pageNumber ?? -1
  
  const query = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.Comment,
      COLUMN_NAMES.DocumentPath,
      COLUMN_NAMES.ETag,
      COLUMN_NAMES.Ekey,
      COLUMN_NAMES.EntityCode,
      COLUMN_NAMES.EntityType,
      COLUMN_NAMES.FileName,
      COLUMN_NAMES.ItemCode,
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemGUID,
      COLUMN_NAMES.InquiryID,
      COLUMN_NAMES.ItemModified,
      COLUMN_NAMES.ItemModifiedBy,
      COLUMN_NAMES.ItemType,
      COLUMN_NAMES.JsonResults,
      COLUMN_NAMES.UserAnswer
    )
    .expand('ItemCreatedBy', 'ItemModifiedBy')
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
  // If a page number is supplied, skip to fetch starting at that page number
  const startAtPageQuery =
    pageNum > -1 ? query.skip(pageNum * PAGE_SIZE) : query

  // If onePageOnly is set to true, only fetch one page of data, otherwise
  // fetch all
  const oneOrManyPagesQuery = onePageOnly
    ? startAtPageQuery.top(PAGE_SIZE)
    : startAtPageQuery
    const items = await oneOrManyPagesQuery.get()
    // const convertedItems = [...items].map((i) => convertDatesInServerObject(i))
    return items as PIIAuditTrail[]
}
export {
  type AuditLog,
  COLUMN_NAMES,
  type GroupedByDay,
  LIST_NAME,
  type PIIAuditTrail,
  type PIIAuditTrailMetadataArgs,
  getPIIAuditTrailListMetadata,
}
